import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { PGUtilities } from '../../utilities/pg-utilities';
import { NotificationsService } from '../../services/notifications.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
    selector: 'app-pg-profile-editor',
    templateUrl: './pg-profile-editor.component.html',
    styleUrls: ['./pg-profile-editor.component.scss'],
    standalone: false
})
export class PgProfileEditorComponent implements OnInit {
    constructor(private authService:AuthService, private notificationsService:NotificationsService, private localizationService:LocalizationService) {}

    @Output() onSave = new EventEmitter<void>();

    ngOnInit(): void {
        this._loadFields();
    }

    formType = {
        email: 'email',
        telephone: 'phone'
    };

    formData: {
        name: string,
        surname: string,
        email: string,
        telephone: string,
        company: string,
        vat_number: string,
    } = null;

    formReadonly: {
        email: boolean,
        telephone: boolean
    } = null;

    formRequired: {
        name: boolean,
        surname: boolean,
        email: boolean,
        telephone: boolean,
        company: boolean,
        vat_number: boolean,
    } = null;

    formRequiredIf = {
        email: () => {
            return (!this.formData.telephone && !this.formData.email)
        },
        telephone: () => {
            return (!this.formData.telephone && !this.formData.email)
        },
    }

    private _loadFields(justUpdate?:'profile'|'user') {
        if(justUpdate == null) {
            this.formData = {
                name: this.authService.user?.name,
                surname: this.authService.user?.surname,
                email: this.authService.user?.email,
                telephone: this.authService.user?.telephone,
                company: this.authService.profile?.company,
                vat_number: this.authService.profile?.vat_number,
            }
        }
        else if(justUpdate == 'user') {
            this.formData.name = this.authService.user?.name
            this.formData.surname = this.authService.user?.surname
            this.formData.email = this.authService.user?.email
            this.formData.telephone = this.authService.user?.telephone
        }
        else if(justUpdate == 'profile') {
            this.formData.company = this.authService.profile?.company
            this.formData.vat_number = this.authService.profile?.vat_number
        }

        this.formReadonly = {
            email: (this.formData.email != null && this.formData.email != ''),
            telephone: (this.formData.telephone != null && this.formData.telephone != '')
        }

        let _extended = this.authService.accessMode == 'business'

        this.formRequired =  {
            name: true,
            surname: true,
            email: _extended,
            telephone: _extended,
            company: _extended,
            vat_number: _extended,
        }
    }

    isFieldReadonly(field:string) {
        return this.isSaving || this.formReadonly[field]
    }

    isFieldSometimesRequired(field:string) {
        return this.formRequired[field] || this.formRequiredIf[field]
    }

    isFieldRequired(field:string) {
        return this.formRequired[field] || (this.formRequiredIf[field] && this.formRequiredIf[field]())
    }

    canSave() {
        if(this.isSaving) return false
        else {
            for(let i in this.formData) {
                let _val = this.formData[i];
    
                if(_val == null || _val == '') return !this.formRequired[i];
                else if(this.formType[i] == 'email') {
                    if(!PGUtilities.emailRegExp.test(_val)) return false;
                }
                else if(this.formType[i] == 'phone') {
                    if(!PGUtilities.phoneRegExp.test(_val)) return false
                }
            }
        }

        return true;
    }

    isSaving = false;

    saveError:'email-taken'|'phone-taken' = null;

    doSave() {
        if(this.canSave()) {
            this.saveError = null;
            this.isSaving = true;
    
            let _toSave = JSON.parse(JSON.stringify(this.formData))
    
            this.authService.setUserProfile({ 
                company: _toSave.company,
                vat_number: _toSave.vat_number
            }).then(() => {
                this.authService.setUserData({ 
                    name: _toSave.name, 
                    surname: _toSave.surname,
                    email: _toSave.email, 
                    telephone: _toSave.telephone 
                }).then(() => {
                    this.isSaving = false;
                    this.notificationsService.addLocalNotification(this.localizationService.translate('pg-profile-editor.save-successful'), 'success', null, null, 3000);
                    this.onSave.emit()
                }, (error) => {
                    this.isSaving = false;
                    this.saveError = error;
                })
            }, () => {
                this.isSaving = false;
            })
        }
    }
}
